'use strict';

export const addToBasket = class {
  // domyślna klasa formularzy, którą filtrujemy
  formClass = 'js-add-to-basket';

  // root dla delegacji (document lub konkretna sekcja)
  root = document;

  container = false;
  loading = false;

  /**
   * Konstruktor:
   * - można przekazać element (root) lub opcje { formClass: 'nazwa-klasy' }
   * - jeśli nie podasz nic, klasa nasłuchuje na document i łapie wszystkie formularze z klasą this.formClass
   *
   * Przykłady:
   *   new addToBasket(); // nasłuchuje document, formClass = 'js-add-to-basket'
   *   new addToBasket({ formClass: 'add-to-basket' });
   *   new addToBasket(document.querySelector('#lista-produktow'), { formClass: 'add-to-basket' });
   *   new addToBasket(document.querySelector('form#singleForm')); // root będzie tym elementem (delegacja w jego kontekście)
   */
  constructor(container = null, options = {}) {
    // jeśli pierwszy argument to obiekt opcji (bez elementu), normalizujemy
    if (
      container &&
      typeof container === 'object' &&
      !(container instanceof Element)
    ) {
      options = container;
      container = null;
    }

    if (options && typeof options === 'object' && options.formClass) {
      this.formClass = options.formClass;
    }

    // jeśli przekazano element, ustawiamy go jako root (delegacja w jego kontekście)
    if (container instanceof Element) {
      this.root = container;
    } else {
      this.root = document;
    }

    this._init();

    return this;
  }

  /**
   * Inicjalizacja: delegowany listener na submit
   * dzięki temu formularze klonowane / dodawane później też będą obsłużone.
   */
  _init = () => {
    // delegacja: łapiemy submity z form wewnątrz root
    this.root.addEventListener('submit', event => {
      // event.target może być formularzem
      const form =
        event.target instanceof HTMLFormElement
          ? event.target
          : event.target.closest('form');

      if (!form) return;
      // jeśli zadeklarowano formClass, filtrujemy po classList
      if (this.formClass && !form.classList.contains(this.formClass)) return;

      // ustawiamy aktualny container na złapany formularz
      this.container = form;

      event.preventDefault();
      this._loading(true);
      this._add(event);
      return false;
    });
  };

  _add = submitEvent => {
    const {
      container,
      _displayErrorsInForm,
      _displayMsgInForm,
      _showReturnInfo,
      _updateBasket,
    } = this;

    if (!container || !(container instanceof HTMLFormElement)) {
      console.warn('Brak formularza (container) do wysłania');
      return;
    }

    let formData = new FormData(container);

    // spróbuj pobrać przycisk, który uruchomił submit (SubmitEvent.submitter)
    let submitter = null;
    if (submitEvent && submitEvent.submitter) {
      submitter = submitEvent.submitter;
    } else {
      // fallback: pierwszy input/button typu submit
      submitter = container.querySelector(
        'button[type="submit"], input[type="submit"]'
      );
    }

    if (submitter && submitter.name) {
      // jeśli przycisk ma name, dołączamy jego name/value
      formData.append(submitter.name, submitter.value || '');
    }

    formData.append('ajax', 1);

    // używamy fetch zamiast $.ajax
    fetch(container.getAttribute('action') || window.location.href, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin', // zachowaj ciasteczka
    })
      .then(response => response.text())
      .then(text => {
        let returnData = {};
        try {
          returnData = JSON.parse(text);
        } catch (e) {
          console.error('Nieprawidłowy JSON z serwera:', e, text);
          this._showReturnInfo(false, []);
          return;
        }
        _showReturnInfo(returnData.status, returnData.msg || []);
        _updateBasket(returnData.status, returnData.data || {});
      })
      .catch(err => {
        console.error('Błąd zapytania:', err);
        _showReturnInfo(false, []);
      })
      .finally(() => {
        // opcjonalnie: automatycznie wyłącz loader po odpowiedzi
        // this._loading(false);
      });
  };

  _loading = status => {
    const { _loadingContainer } = this;

    if (status) {
      // jeśli już istnieje loader, nie dodajemy kolejnego
      if (document.querySelector('.basket-form-loading-container'))
        return false;

      // wstawiamy zawartość generowaną przez _loadingContainer()
      const temp = document.createElement('div');
      temp.innerHTML = _loadingContainer().trim();
      // temp.firstElementChild to element .basket-form-loading-container
      const node = temp.firstElementChild;
      if (node) document.body.appendChild(node);
    } else {
      const el = document.querySelector('.basket-form-loading-container');
      if (el) el.remove();
    }
  };

  _showReturnInfo = (status, msg) => {
    const { container, _loading, _returnInfoContainer } = this;

    const isLoading = document.querySelector('.basket-form-loading-container');
    if (!isLoading) return false;

    isLoading.innerHTML = _returnInfoContainer(status, msg);

    // przycisk error: tylko zamyka komunikat
    const btnError = isLoading.querySelector('.form-return-button--error');
    if (btnError) {
      btnError.addEventListener('click', event => {
        event.preventDefault();
        _loading(false);
        return false;
      });
    }

    // przycisk ok: zamyka komunikat i resetuje formularz
    const btnOk = isLoading.querySelector('.form-return-button--ok');
    if (btnOk) {
      btnOk.addEventListener('click', event => {
        event.preventDefault();
        _loading(false);
        try {
          container.reset();
        } catch (e) {
          // ignore
        }
        return false;
      });
    }
  };

  _svgIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-add-to-basket-icon" style="fill-rule:evenodd;"> <g transform="matrix(1.87849,0,0,1.87849,12.6249,29.9428)"><path d="M97,0C111.204,0.007 122.888,11.696 122.888,25.9C122.888,40.108 111.196,51.8 96.988,51.8C82.78,51.8 71.088,40.108 71.088,25.9C71.088,19.036 73.817,12.445 78.67,7.59C83.522,2.719 90.125,-0.015 97,0ZM3.66,10.89C1.625,10.89 -0.05,9.215 -0.05,7.18C-0.05,5.145 1.625,3.47 3.66,3.47L9.11,3.47C12.23,3.434 15.302,4.243 18,5.81C22.92,8.93 23.79,13.38 25,18.4L66.7,18.4C66.109,20.799 65.807,23.26 65.8,25.73L27.14,25.73L35.5,57.19L94.77,57.19L94.77,57.01C95.49,57.06 96.21,57.09 96.94,57.09C98.77,57.088 100.597,56.928 102.4,56.61L101.11,61.79C100.734,63.448 99.24,64.629 97.54,64.61L37.47,64.61C38.79,69.49 40.1,72.12 41.89,73.35C44.05,74.75 47.81,74.85 54.1,74.75L96.64,74.75C96.704,74.747 96.768,74.745 96.832,74.745C98.845,74.745 100.502,76.402 100.502,78.415C100.502,80.428 98.845,82.085 96.832,82.085C96.768,82.085 96.704,82.083 96.64,82.08L54.19,82.08C46.4,82.17 41.61,81.99 37.75,79.45C33.89,76.91 31.75,72.31 29.68,64.14L17.09,16.52C17.09,16.43 17.09,16.43 17,16.33C16.67,14.6 15.652,13.077 14.18,12.11C12.605,11.219 10.807,10.795 9,10.89L3.66,10.89ZM60.87,33.47C61.101,32.246 62.18,31.352 63.425,31.352C64.67,31.352 65.749,32.246 65.98,33.47L65.98,47.63C65.749,48.854 64.67,49.748 63.425,49.748C62.18,49.748 61.101,48.854 60.87,47.63L60.87,33.47ZM45.57,33.47C45.801,32.246 46.88,31.352 48.125,31.352C49.37,31.352 50.449,32.246 50.68,33.47L50.68,47.63C50.449,48.854 49.37,49.748 48.125,49.748C46.88,49.748 45.801,48.854 45.57,47.63L45.57,33.47ZM85.66,86.4C90.597,86.4 94.66,90.463 94.66,95.4C94.66,100.337 90.597,104.4 85.66,104.4C80.723,104.4 76.66,100.337 76.66,95.4C76.66,90.463 80.723,86.4 85.66,86.4ZM46.11,86.4C51.047,86.4 55.11,90.463 55.11,95.4C55.11,100.337 51.047,104.4 46.11,104.4C41.173,104.4 37.11,100.337 37.11,95.4C37.11,90.463 41.173,86.4 46.11,86.4ZM110.19,23.49L110.19,28.3C110.179,29.431 109.251,30.359 108.12,30.37L101.46,30.37L101.46,37C101.455,38.134 100.524,39.065 99.39,39.07L94.58,39.07C93.444,39.07 92.51,38.136 92.51,37L92.51,30.37L85.85,30.37C84.716,30.365 83.785,29.434 83.78,28.3L83.78,23.49C83.78,22.354 84.714,21.42 85.85,21.42L92.51,21.42L92.51,14.76C92.51,13.624 93.444,12.69 94.58,12.69L99.39,12.69C100.524,12.695 101.455,13.626 101.46,14.76L101.46,21.42L108.12,21.42C109.254,21.425 110.185,22.356 110.19,23.49Z"/></g></svg>';
  };

  _svgFailIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-add-to-basket-fail-icon" style="fill-rule:evenodd;"> <g transform="matrix(1.87849,0,0,1.87849,12.6249,29.9428)"><path d="M97,0C111.204,0.007 122.888,11.696 122.888,25.9C122.888,40.108 111.196,51.8 96.988,51.8C82.78,51.8 71.088,40.108 71.088,25.9C71.088,19.036 73.817,12.445 78.67,7.59C83.522,2.719 90.125,-0.015 97,0ZM3.66,10.89C1.625,10.89 -0.05,9.215 -0.05,7.18C-0.05,5.145 1.625,3.47 3.66,3.47L9.11,3.47C12.23,3.434 15.302,4.243 18,5.81C22.92,8.93 23.79,13.38 25,18.4L66.7,18.4C66.109,20.799 65.807,23.26 65.8,25.73L27.14,25.73L35.5,57.19L94.77,57.19L94.77,57.01C95.49,57.06 96.21,57.09 96.94,57.09C98.77,57.088 100.597,56.928 102.4,56.61L101.11,61.79C100.734,63.448 99.24,64.629 97.54,64.61L37.47,64.61C38.79,69.49 40.1,72.12 41.89,73.35C44.05,74.75 47.81,74.85 54.1,74.75L96.64,74.75C96.704,74.747 96.768,74.745 96.832,74.745C98.845,74.745 100.502,76.402 100.502,78.415C100.502,80.428 98.845,82.085 96.832,82.085C96.768,82.085 96.704,82.083 96.64,82.08L54.19,82.08C46.4,82.17 41.61,81.99 37.75,79.45C33.89,76.91 31.75,72.31 29.68,64.14L17.09,16.52C17.09,16.43 17.09,16.43 17,16.33C16.67,14.6 15.652,13.077 14.18,12.11C12.605,11.219 10.807,10.795 9,10.89L3.66,10.89ZM60.87,33.47C61.101,32.246 62.18,31.352 63.425,31.352C64.67,31.352 65.749,32.246 65.98,33.47L65.98,47.63C65.749,48.854 64.67,49.748 63.425,49.748C62.18,49.748 61.101,48.854 60.87,47.63L60.87,33.47ZM45.57,33.47C45.801,32.246 46.88,31.352 48.125,31.352C49.37,31.352 50.449,32.246 50.68,33.47L50.68,47.63C50.449,48.854 49.37,49.748 48.125,49.748C46.88,49.748 45.801,48.854 45.57,47.63L45.57,33.47ZM85.66,86.4C90.597,86.4 94.66,90.463 94.66,95.4C94.66,100.337 90.597,104.4 85.66,104.4C80.723,104.4 76.66,100.337 76.66,95.4C76.66,90.463 80.723,86.4 85.66,86.4ZM46.11,86.4C51.047,86.4 55.11,90.463 55.11,95.4C55.11,100.337 51.047,104.4 46.11,104.4C41.173,104.4 37.11,100.337 37.11,95.4C37.11,90.463 41.173,86.4 46.11,86.4ZM110.19,23.49L110.19,28.3C110.179,29.431 109.251,30.359 108.12,30.37L101.46,30.37L101.46,37C101.455,38.134 100.524,39.065 99.39,39.07L94.58,39.07C93.444,39.07 92.51,38.136 92.51,37L92.51,30.37L85.85,30.37C84.716,30.365 83.785,29.434 83.78,28.3L83.78,23.49C83.78,22.354 84.714,21.42 85.85,21.42L92.51,21.42L92.51,14.76C92.51,13.624 93.444,12.69 94.58,12.69L99.39,12.69C100.524,12.695 101.455,13.626 101.46,14.76L101.46,21.42L108.12,21.42C109.254,21.425 110.185,22.356 110.19,23.49Z"/></g></svg>';
  };

  _svgOkIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-add-to-basket-ok-icon" style="fill-rule:evenodd;"> <g transform="matrix(1.87849,0,0,1.87849,12.6249,29.9428)"><path d="M97,0C111.204,0.007 122.888,11.696 122.888,25.9C122.888,40.108 111.196,51.8 96.988,51.8C82.78,51.8 71.088,40.108 71.088,25.9C71.088,19.036 73.817,12.445 78.67,7.59C83.522,2.719 90.125,-0.015 97,0ZM3.66,10.89C1.625,10.89 -0.05,9.215 -0.05,7.18C-0.05,5.145 1.625,3.47 3.66,3.47L9.11,3.47C12.23,3.434 15.302,4.243 18,5.81C22.92,8.93 23.79,13.38 25,18.4L66.7,18.4C66.109,20.799 65.807,23.26 65.8,25.73L27.14,25.73L35.5,57.19L94.77,57.19L94.77,57.01C95.49,57.06 96.21,57.09 96.94,57.09C98.77,57.088 100.597,56.928 102.4,56.61L101.11,61.79C100.734,63.448 99.24,64.629 97.54,64.61L37.47,64.61C38.79,69.49 40.1,72.12 41.89,73.35C44.05,74.75 47.81,74.85 54.1,74.75L96.64,74.75C96.704,74.747 96.768,74.745 96.832,74.745C98.845,74.745 100.502,76.402 100.502,78.415C100.502,80.428 98.845,82.085 96.832,82.085C96.768,82.085 96.704,82.083 96.64,82.08L54.19,82.08C46.4,82.17 41.61,81.99 37.75,79.45C33.89,76.91 31.75,72.31 29.68,64.14L17.09,16.52C17.09,16.43 17.09,16.43 17,16.33C16.67,14.6 15.652,13.077 14.18,12.11C12.605,11.219 10.807,10.795 9,10.89L3.66,10.89ZM60.87,33.47C61.101,32.246 62.18,31.352 63.425,31.352C64.67,31.352 65.749,32.246 65.98,33.47L65.98,47.63C65.749,48.854 64.67,49.748 63.425,49.748C62.18,49.748 61.101,48.854 60.87,47.63L60.87,33.47ZM45.57,33.47C45.801,32.246 46.88,31.352 48.125,31.352C49.37,31.352 50.449,32.246 50.68,33.47L50.68,47.63C50.449,48.854 49.37,49.748 48.125,49.748C46.88,49.748 45.801,48.854 45.57,47.63L45.57,33.47ZM85.66,86.4C90.597,86.4 94.66,90.463 94.66,95.4C94.66,100.337 90.597,104.4 85.66,104.4C80.723,104.4 76.66,100.337 76.66,95.4C76.66,90.463 80.723,86.4 85.66,86.4ZM46.11,86.4C51.047,86.4 55.11,90.463 55.11,95.4C55.11,100.337 51.047,104.4 46.11,104.4C41.173,104.4 37.11,100.337 37.11,95.4C37.11,90.463 41.173,86.4 46.11,86.4ZM110.19,23.49L110.19,28.3C110.179,29.431 109.251,30.359 108.12,30.37L101.46,30.37L101.46,37C101.455,38.134 100.524,39.065 99.39,39.07L94.58,39.07C93.444,39.07 92.51,38.136 92.51,37L92.51,30.37L85.85,30.37C84.716,30.365 83.785,29.434 83.78,28.3L83.78,23.49C83.78,22.354 84.714,21.42 85.85,21.42L92.51,21.42L92.51,14.76C92.51,13.624 93.444,12.69 94.58,12.69L99.39,12.69C100.524,12.695 101.455,13.626 101.46,14.76L101.46,21.42L108.12,21.42C109.254,21.425 110.185,22.356 110.19,23.49Z"/></g></svg>';
  };

  _loadingContainer = () => {
    const { _svgIcon } = this;
    return `<div class="basket-form-loading-container"><div class="form-loading__center"><div class="form-loading__icon--sending">${_svgIcon()}</div><div class="form-loading__progress-bar"></div><div class="form-loading__label">dodawanie produktu do koszyka</div></div></div>`;
  };

  _returnInfoContainer = (status, msg) => {
    const { _svgFailIcon, _svgOkIcon } = this;

    let container = `<div class="basket-form-return-info-container ${
      status
        ? 'form-return-info-container--ok'
        : 'form-return-info-container--error'
    }">`;
    container += '<div class="form-return-info__center">';
    container += `<div class="form-return-info__icon">${
      status ? _svgOkIcon() : _svgFailIcon()
    }</div>`;
    container += `<h2 class="form-return-info__header">${
      status
        ? 'Produkt został dodany do koszyka'
        : 'Niestety. Nie udało się dodac produktu do koszyka.'
    }</h2>`;
    if (!status && msg && msg.length) {
      container += '<div class="form-return-info__msg-container">';
      [...msg].forEach(element => {
        container += `<p class="form-msg form-msg--${element.typ}">${element.tresc}</p>`;
      });
      container += '</div>';
    }
    container += '<div class="form-return-info__buttons-container">';
    container += `<a href="#" class="form-return-button form-return-button--${
      status ? 'ok' : 'error'
    }">${status ? 'wróć do strony' : 'wróć do strony'}</a>`;
    container += `<a href="/koszyk" class="form-do-koszyka">przejdź do koszyka</a>`;
    container += '</div>';
    container += '</div>';
    container += '</div>';

    return container;
  };

  _updateBasket = (status, data) => {
    if (status && data && typeof data.wartosc !== 'undefined') {
      const el = document.querySelector('header .koszyk-wartosc-ajax');
      if (el) {
        el.textContent = Number(data.wartosc).toFixed(2);
      }
    }
  };
};
